import { useQuery } from '@tanstack/react-query';
import type { ChatbotRankingCriteria } from '@liks/lac-svc-api/esm/models/index';
import { lacAnalyticsService } from '../../../services/LacAnalyticsService';
import type { LacTenantOverviewDateRange } from '../../../types/lac';
import { lacQueryKeys } from '../lacQueryKeys';

export function useLacTopChatbotsQuery(
  tenantName: string | undefined | null,
  criteria: ChatbotRankingCriteria,
  knowledgeBaseId?: string | null,
  range?: LacTenantOverviewDateRange,
  limit?: number,
) {
  const scopedTenantName = tenantName?.trim() || null;

  return useQuery({
    queryKey: lacQueryKeys.topChatbots(
      scopedTenantName,
      criteria,
      knowledgeBaseId ?? null,
      range ?? null,
      limit ?? null,
    ),
    queryFn: () =>
      lacAnalyticsService.listTopChatbots({
        tenantName: scopedTenantName ?? undefined,
        criteria,
        knowledgeBaseId,
        range,
        limit,
      }),
  });
}
